import React from 'react';

export default function PreviewStep({ file, parsed }) {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-4">
        <div className="p-3 rounded-lg bg-white border border-slate-200">
          <div className="text-[10px] font-semibold text-slate-500 uppercase tracking-wider">File</div>
          <div className="text-xs font-bold text-slate-900 truncate mt-0.5" title={file?.name}>{file?.name || '—'}</div>
        </div>
        <div className="p-3 rounded-lg bg-white border border-slate-200">
          <div className="text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Sheets Detected</div>
          <div className="flex items-center gap-1 flex-wrap mt-1">
            {parsed.sheetNames.map((s) => (
              <span key={s} className="px-1.5 py-0.5 rounded bg-slate-100 text-[10px] font-bold text-slate-700">{s}</span>
            ))}
          </div>
        </div>
        <div className="p-3 rounded-lg bg-white border border-slate-200">
          <div className="text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Columns</div>
          <div className="text-xl font-bold text-slate-900 mt-0.5">{parsed.headers.length}</div>
        </div>
        <div className="p-3 rounded-lg bg-white border border-slate-200">
          <div className="text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Rows</div>
          <div className="text-xl font-bold text-slate-900 mt-0.5">{parsed.rows.length}</div>
        </div>
      </div>

      <div className="mb-3">
        <div className="text-[10px] font-semibold text-slate-500 uppercase tracking-wider mb-2">Detected Columns</div>
        <div className="flex flex-wrap gap-1.5">
          {parsed.headers.map((h, i) => (
            <span key={`hdr-${i}-${h}`} className="px-2 py-1 rounded-md bg-slate-100 text-[10px] font-medium text-slate-700 border border-slate-200">
              {h || `(Col ${i + 1})`}
            </span>
          ))}
        </div>
      </div>

      <div className="rounded-xl border border-slate-200 overflow-hidden bg-white">
        <div className="px-4 py-2.5 bg-slate-50 border-b border-slate-100 text-[11px] font-semibold text-slate-700">
          First {Math.min(10, parsed.rows.length)} rows preview
        </div>
        <div className="overflow-x-auto max-h-[340px] overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 sticky top-0">
              <tr>
                <th className="px-3 py-2 text-[10px] font-semibold text-slate-500 uppercase tracking-wider text-right w-10">#</th>
                {parsed.headers.map((h, i) => (
                  <th key={`th-${i}-${h}`} className="px-3 py-2 text-left text-[10px] font-semibold text-slate-500 uppercase tracking-wider whitespace-nowrap">
                    {h || `Col ${i + 1}`}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {parsed.rows.slice(0, 10).map((row, ri) => (
                <tr key={`preview-row-${ri}`} className="border-t border-slate-100 hover:bg-slate-50/40">
                  <td className="px-3 py-2 text-right text-[10px] text-slate-400 font-mono">{ri + 1}</td>
                  {parsed.headers.map((_, ci) => (
                    <td key={`preview-cell-${ri}-${ci}`} className="px-3 py-2 text-xs text-slate-700 whitespace-nowrap max-w-[260px] truncate" title={row[ci]}>
                      {row[ci] || <span className="text-slate-300">—</span>}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
